'use client';

import CmsImage from '@/components/ui/CmsImage';
import { MEDIA_PLACEHOLDER } from '@/lib/media-placeholder';
import { getStrapiMediaUrl } from '@/lib/strapi-media-url';
import type { PncImageTicker } from '@/types/people-and-culture';

interface PhotoMarqueeProps {
  zone: PncImageTicker;
}

export default function PhotoMarquee({ zone }: PhotoMarqueeProps) {
  const images = (zone.imageTickerItem ?? []).map(
    (item) => getStrapiMediaUrl(item.media, 'large') ?? null,
  );

  if (images.length === 0) return null;

  const stripImages = [...images, ...images, ...images];

  return (
    <div className="photo-marquee-wrap h-36 w-full overflow-hidden sm:h-44 md:h-56">
      <div className="photo-marquee-track flex h-full w-max">
        {stripImages.map((src, i) => (
          <div key={i} className="relative h-full w-56 shrink-0 overflow-hidden sm:w-72 md:w-96">
            <CmsImage
              src={src}
              alt=""
              fill
              sizes="384px"
              className="object-cover transition-transform duration-500 hover:scale-105"
              fallbackSrc={MEDIA_PLACEHOLDER}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
